(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("date-fns"));
	else if(typeof define === 'function' && define.amd)
		define("VuetifyDatetimePicker", ["date-fns"], factory);
	else if(typeof exports === 'object')
		exports["VuetifyDatetimePicker"] = factory(require("date-fns"));
	else
		root["VuetifyDatetimePicker"] = factory(root["date-fns"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 